import { PRODUCT_SLUGS } from '@discover-frontend/constants';

const MOCK_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3001'
    : 'https://helixa-account-mock-api.herokuapp.com';

const BASE_URL = {
  develop: 'https://api-develop-accounts.helixa.ai',
  staging: 'https://api-staging-accounts.helixa.ai',
  production: 'https://api-accounts.helixa.ai',
};

const BASE_URL_APP_SERVICES = {
  develop: 'https://develop-app-services.helixa.ai',
  staging: 'https://staging-app-services.helixa.ai',
  production: 'https://app-services.helixa.ai',
};

export const API = {
  BASE_URL: BASE_URL[process.env.REACT_APP_API_ENV],
  MOCK_BASE_URL,
  APP_SERVICES: {
    BASE_URL: BASE_URL_APP_SERVICES[process.env.REACT_APP_API_ENV],
  },
};

export const SSO_URLS = {
  localhost: {
    REACT_APP_ID_SERVER_BASE: `//localhost-home.helixa.ai:3003`,
    REACT_APP_ID_SERVER_AUTH: `//localhost-home.helixa.ai:3003/login`,
  },
  develop: {
    REACT_APP_ID_SERVER_BASE: `//develop-home.helixa.ai`,
    REACT_APP_ID_SERVER_AUTH: `//develop-home.helixa.ai/login`,
  },
  staging: {
    REACT_APP_ID_SERVER_BASE: '//staging-home.helixa.ai',
    REACT_APP_ID_SERVER_AUTH: '//staging-home.helixa.ai/login',
  },
  production: {
    REACT_APP_ID_SERVER_BASE: '//home.helixa.ai',
    REACT_APP_ID_SERVER_AUTH: '//home.helixa.ai/login',
  },
};

export const ICONS = {
  products: {
    [PRODUCT_SLUGS.AFFINITY_GLOBAL]: 'country',
    [PRODUCT_SLUGS.AFFINITY_US]: 'usa',
    [PRODUCT_SLUGS.HELIXA_CSM]: 'support',
    [PRODUCT_SLUGS.AFFINITY_US_GWI]: 'usa',
    [PRODUCT_SLUGS.AFFINITY_WW_GWI_MED]: 'icon-country',
    [PRODUCT_SLUGS.DOCUMENTATION]: 'icon-ticket',
  },
};

export const SERVICE_DESCRIPTIONS_URL =
  'https://telmarhelixa.com/service-descriptions';

export const PRIVACY_URL = 'https://www.helixa.ai/privacy-policy';

export const FRESHDESK_URL = '//resources.helixa.ai';
